import { render, staticRenderFns } from "./vendor-references.vue?vue&type=template&id=a71d032a&"
import script from "./vendor-references.vue?vue&type=script&lang=js&"
export * from "./vendor-references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports